<template>
  <LayoutHeader main="emailAfter" ref="layout" :loadingOverlay="loadingOverlay" :me="me" :lastApp="lastApp" :appHistory="appHistory">
    <article>
      <div v-if="step == 'complete'">
        <h1 class="text-center mb-4">メールアドレスを変更しました</h1>
        <div class="text-center mb-2">新しいメールアドレス</div>
        <div class="text-center mb-5"><strong class="fs-2">{{ after }}</strong></div>
      </div>
      <div v-else-if="step == 'invalidKey'">
        <h1 class="text-center">このURLは無効です</h1>
      </div>
      <div class="mb-5 text-center">
        <router-link class="text-decoration-underline" :to="{ name: 'Top' }">ホームへ</router-link>
      </div>
    </article>
  </LayoutHeader>
</template>

<script>
import baseMixin from './base'

export default {
  mixins: [
    baseMixin,
  ],
  data () {
    return {
      titlePrefix: 'メールアドレスの変更',
      step: this.$route.query.step ?? '',
      after: this.$route.query.after ?? '',
    }
  },
  methods: {
  },
}
</script>

